@if (!ruleEngine.disabled()) {
  @if (ruleEngine.allowCustomAttributeNames()) {
    <coin-v2-text-input
      required
      [attr.aria-label]="'general.rule-engine.field' | translate"
      [autoCompleteOptions]="fields()"
      [(ngModel)]="rule().field"
      (ngModelChange)="resetOperatorAndValue()"></coin-v2-text-input>
  } @else {
    <coin-v2-dropdown
      #fieldSearch="dropdownSearch"
      required
      [dataSource]="ruleEngine.searchTranslatedFields$ | async"
      [searchDebounce]="0"
      [attr.aria-label]="'general.rule-engine.field' | translate"
      [(ngModel)]="rule().field"
      (ngModelChange)="resetOperatorAndValue()">
      @for (field of fieldSearch.results(); track field.key) {
        <ng-template [coinValue]="field.key">{{ field.translation }}</ng-template>
      }
    </coin-v2-dropdown>
  }
} @else {
  <span>{{ translatedField }}</span>
}

@if (!ruleEngine.disabled()) {
  <button
    class="no-style operator"
    [matMenuTriggerFor]="rule().field && ruleConfig?.operators ? operatorOptions : null"
    [disabled]="!rule().field">
    @if (rule().operator) {
      <coin-v2-lightweight-operator-icon
        [operator]="rule().operator"
        [matTooltip]="rule().operator | enumToText"></coin-v2-lightweight-operator-icon>
    }
  </button>

  <mat-menu #operatorOptions="matMenu">
    @for (operator of ruleConfig?.operators ?? []; track operator) {
      <button
        mat-menu-item
        class="text"
        [disabled]="operator === rule().operator"
        (click)="setOperator(operator)">
        <div class="menu-option-container">
          <coin-v2-lightweight-operator-icon [operator]="operator"></coin-v2-lightweight-operator-icon>
          <span>{{ operator | enumToText }}</span>
        </div>
      </button>
    }
  </mat-menu>
} @else {
  <div
    class="operator"
    matTooltipPosition="above"
    [matTooltip]="rule().operator | enumToText"
    [matTooltipDisabled]="!rule().operator">
    @if (rule().operator) {
      <coin-v2-lightweight-operator-icon [operator]="rule().operator"></coin-v2-lightweight-operator-icon>
    }
  </div>
}

@if (!ruleEngine.disabled() && !isValuelessOperator(rule().operator)) {
  <div class="rule-engine-input">
    @let ruleConfigType = $safeNavigationMigration(ruleConfig?.type);
    @if (typeof ruleConfigType === 'object') {
      <!-- component type input -->
      <ng-container *ngComponentOutlet="$safeNavigationMigration(ruleConfigType?.component)"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="ruleInputTemplate(); context: { $implicit: ruleConfigType }"></ng-container>
    }
  </div>
} @else {
  @switch (ruleConfig?.type) {
    @case ('System.DateTime') {
      <span>{{ $any(rule().value) | date }}</span>
    }
    @default {
      <span>{{ rule().value }}</span>
    }
  }
}

@if (!ruleEngine.disabled()) {
  <button
    class="no-style delete"
    [disabled]="!deletable()"
    [matTooltipDisabled]="deletable()"
    [matTooltip]="'general.rule-tooltip' | translate"
    (click)="onDeleteClick()">
    <mat-icon>delete</mat-icon>
  </button>
}

<!-- TODO: could be its own component instead of a template -->
<ng-template
  #ruleInput
  let-type>
  @let inputType = asRuleEngineInputType(type);
  @switch (inputType) {
    @case ('System.Boolean') {
      <coin-v2-checkbox
        required
        [disabled]="isRuleValueDisabled"
        [attr.aria-label]="'general.rule-engine.value' | translate"
        [(ngModel)]="rule().value[0]"
        (ngModelChange)="ruleEngine.registerChanges()"></coin-v2-checkbox>
    }
    @default {
      @if (!rule().operator || FREE_TEXT_OPERATORS.has(rule().operator)) {
        <ng-container *ngTemplateOutlet="rawInputs"></ng-container>
      } @else {
        @let fieldValues = ruleConfig?.fieldValues$ ? (ruleConfig.fieldValues$ | async) : [];
        @if (fieldValues?.length) {
          <coin-v2-dropdown
            #fieldValueSearch="dropdownSearch"
            required
            [dataSource]="fieldValues"
            [disabled]="isRuleValueDisabled"
            [multiple]="true"
            [attr.aria-label]="'general.rule-engine.value' | translate"
            [(ngModel)]="rule().value"
            (ngModelChange)="ruleEngine.registerChanges()">
            @if (rule().field) {
              @for (fieldValue of fieldValueSearch.results() | sortAlphabetically; track fieldValue) {
                <ng-template [coinValue]="fieldValue">
                  {{ fieldValue }}
                </ng-template>
              }
            }
          </coin-v2-dropdown>
        } @else {
          <ng-container *ngTemplateOutlet="rawInputs"></ng-container>
        }
      }
      <ng-template #rawInputs>
        @switch (inputType) {
          @case ('System.String') {
            <coin-v2-text-input
              required
              [disabled]="isRuleValueDisabled"
              [attr.aria-label]="'general.rule-engine.value' | translate"
              [(ngModel)]="rule().value[0]"
              (ngModelChange)="ruleEngine.registerChanges()"></coin-v2-text-input>
          }
          @case ('System.DateTime') {
            <coin-v2-date-input
              required
              [disabled]="isRuleValueDisabled"
              [attr.aria-label]="'general.rule-engine.value' | translate"
              [(ngModel)]="rule().value[0]"
              (ngModelChange)="ruleEngine.registerChanges()"></coin-v2-date-input>
          }
          @case ('System.Int32') {
            <ng-container *ngTemplateOutlet="numberInput"></ng-container>
          }
          @case ('System.Double') {
            <ng-container *ngTemplateOutlet="numberInput"></ng-container>
          }
          @case ('System.Decimal') {
            <ng-container *ngTemplateOutlet="numberInput"></ng-container>
          }
        }
      </ng-template>
    }
  }

  <ng-template #numberInput>
    <coin-v2-number-input
      required
      [disabled]="isRuleValueDisabled"
      [attr.aria-label]="'general.rule-engine.value' | translate"
      [(ngModel)]="rule().value[0]"
      (ngModelChange)="ruleEngine.registerChanges()"></coin-v2-number-input>
  </ng-template>
</ng-template>
